module.exports = __webpack_public_path__ + "img/banner.211aa652.png";